<template>
  <div class="home">
    <el-container id="ct1">
      <el-header>
        <TopSideBar />
      </el-header>
      <el-container id="ct2">
        <Menu v-show="userType == '00'" />
        <el-container v-if="userType == '00'">
          <v-tags></v-tags>
          <div style="margin: 39px 0 0 0; width: 100%">
            <transition name="move" mode="out-in">
              <keep-alive :include="tagsList">
                <router-view></router-view>
              </keep-alive>
            </transition>
          </div>
        </el-container>
        <el-container v-else>
          <router-view></router-view>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script type="text/ecmascript-6">
import '../assets/css/main.css'
import TopSideBar from '@/components/topSide/sideBar.vue'
import {mapGetters} from 'vuex'
import Menu from '@/components/Menu/index.vue'
import store from '../store'
import { getShopList } from "@/api/shop/shop";
import { getToken } from '@/utils/auth'
import { getDictData } from "@/api/system/dict/data";
import vTags from '@/components/Tags';
import bus from '@/utils/bus';

export default {
  name: 'Home',
  data(){
    return {
      userType: '00',
      tagsList: [],
    }
  },
  components: {
    TopSideBar,
    Menu,
    vTags
  },
  computed:{
    ...mapGetters(['orderStatus', 'user']),
  },
  watch:{
    user: {
      handler(){
        // console.log('userType' + this.user.userType)
        this.userType = this.user.userType
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    store.dispatch('getNginx');
    this.loadInitData();
     bus.$on('collapse-content', msg => {
      this.collapse = msg;
    });

    // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
    bus.$on('tags', msg => {
      let arr = [];
      for (let i = 0, len = msg.length; i < len; i++) {
        msg[i].title && arr.push(msg[i].title);
      }
      this.tagsList = arr;
    });
  },
  mounted() {
    if (getToken()) {
      getDictData().then((result) => {
        this.$store.commit("SET_DICT_DATA", result.data)
      })
      this.$store.dispatch("GetIndexStat")
    }
  },
  methods:{
    loadInitData(){
    }
  }
}
</script>
<style scoped>
.home {
  height: 100%;
}
.el-header {
  background-color: #1d7ef2;
  color: #333;
  text-align: center;
  line-height: 50px;
  padding: 0 20px;
  z-index: 999 !important;
  height: 50px !important;
  /*position: relative;*/
}
.el-aside {
  background-color: rgba(226, 242, 255, 0);
  color: #333;
  margin: 15px;
  text-align: center;
  line-height: 200px;
}

.el-main {
  background-color: white;
  color: #333;
}

#ct1 {
  width: 100%;
  height: 100%;
}
</style>
